/**
 * @generated SignedSource<<3513be3b45ccc5c20c35e45fd87fce1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type accountDropzone_BankAccountCreateMutation$variables = {
  kind: string;
  nickname?: string | null | undefined;
  number: string;
};
export type accountDropzone_BankAccountCreateMutation$data = {
  readonly bankAccountCreate: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly number: string | null | undefined;
  } | null | undefined;
};
export type accountDropzone_BankAccountCreateMutation = {
  response: accountDropzone_BankAccountCreateMutation$data;
  variables: accountDropzone_BankAccountCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kind"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nickname"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "number"
},
v3 = [
  {
    "kind": "Variable",
    "name": "kind",
    "variableName": "kind"
  },
  {
    "kind": "Variable",
    "name": "nickname",
    "variableName": "nickname"
  },
  {
    "kind": "Variable",
    "name": "number",
    "variableName": "number"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "accountDropzone_BankAccountCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "BankAccountCreateMutationPayload",
        "kind": "LinkedField",
        "name": "bankAccountCreate",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "accountDropzone_BankAccountCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "BankAccountCreateMutationPayload",
        "kind": "LinkedField",
        "name": "bankAccountCreate",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "83b2b437a11011d0bd0e998a47e1dfdf",
    "id": null,
    "metadata": {},
    "name": "accountDropzone_BankAccountCreateMutation",
    "operationKind": "mutation",
    "text": "mutation accountDropzone_BankAccountCreateMutation(\n  $number: String!\n  $nickname: String\n  $kind: String!\n) {\n  bankAccountCreate(number: $number, nickname: $nickname, kind: $kind) {\n    number\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "abdd4233c7f5a7d4686c2544c937c1d5";

export default node;
